import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectFinanceTab, ProjectProfitabilityTab } from '@/features/finance';
// Route options read the light search module; the page is code-split with the component.
import { DEFAULT_WORKSPACE_SECTION, isWorkspaceSection } from '@/features/projects/search';
import { ProjectWorkspace } from '@/features/projects/workspace/project-workspace';

/**
 * The project workspace: one project full screen, meant for its own browser tab (the project
 * page's "Project workspace" button). The section is a segment of the address.
 */
export const Route = createFileRoute('/_auth/o/$orgId/projects/$projectId/workspace/$section')({
  // An unknown section falls back to the overview instead of a dead end.
  beforeLoad: ({ params }) => {
    if (!isWorkspaceSection(params.section)) {
      redirect({
        to: '/o/$orgId/projects/$projectId/workspace/$section',
        params: { ...params, section: DEFAULT_WORKSPACE_SECTION },
        replace: true,
        throw: true,
      });
    }
  },
  component: WorkspaceRoute,
});

function WorkspaceRoute() {
  const { orgId, projectId, section } = Route.useParams();
  return (
    <ProjectWorkspace
      orgId={orgId}
      projectId={projectId}
      section={isWorkspaceSection(section) ? section : DEFAULT_WORKSPACE_SECTION}
      renderFinanceTab={(project) => <ProjectFinanceTab orgId={orgId} projectId={project.id} />}
      renderProfitabilityTab={(project) => (
        <ProjectProfitabilityTab orgId={orgId} projectId={project.id} />
      )}
    />
  );
}
